import React from 'react'
import { Image, Dialog, Input, Selector, Toast, Tag } from 'antd-mobile';
import API_ROUTES from '../../api';
import { colorList } from '../../Applicate/ApplicateTwo/color';
import axios from 'axios';
import Icon from '../../icon';

const HistoryTitle = ({ gameDetail, getGameDetail }) => {

    const userInfo = localStorage.getItem("memberInfo")
    const memberInfo = userInfo ? JSON.parse(userInfo) : null;
    const currentGameType = Number(gameDetail?.gameType ?? gameDetail?.game_type);
    const isExternalMatch = [1, 2].includes(currentGameType);
    const isValidTeamImage = (url) => typeof url === 'string' && url.startsWith('https');
    const withImageFooter = (url) => isValidTeamImage(url) ? url + Icon.ImageFooter : '';
    const getMemberDefaultAvatar = (member) => {
        // 外战对手本质是临时队员，比分牌头像按队员默认头像优先读取。
        const memberDefaultImage = member?.memberImageList?.find(item => Number(item.type) === 0)?.image;
        if (memberDefaultImage) return memberDefaultImage + Icon.ImageFooter;
        if (isValidTeamImage(member?.image)) return member.image + Icon.ImageFooter;
        if (isValidTeamImage(member?.memberImage)) return member.memberImage + Icon.ImageFooter;
        return '';
    };

    const getLogoInfo = (team) => {
        // 年会外战队伍没有队徽时显示圆形队名，不使用科朋默认队徽。
        if (currentGameType === 4) {
            const teamType = team === 1 ? gameDetail?.greenTeamType : gameDetail?.redTeamType;
            const logo = team === 1 ? gameDetail?.greenTeamLogo : gameDetail?.redTeamLogo;
            return logo ? logo + Icon.ImageFooter : (Number(teamType) === 1 ? '' : Icon.KEPENG_LOGO);
        }
        if (team === 1) {
            if (isExternalMatch) {
                return Icon.KEPENG_LOGO
            }
            if (gameDetail?.greenTeamLogo) {
                return gameDetail?.greenTeamLogo + Icon.ImageFooter
            } else {
                return Icon.KEPENG_LOGO
            }
        } else if (team === 2) {
            if (isExternalMatch) {
                // 对外赛对手是临时队员，优先使用后端统一返回的队员默认头像。
                return withImageFooter(gameDetail?.redCaptainImage) || getMemberDefaultAvatar(gameDetail?.redCaptain) || withImageFooter(gameDetail?.redImage) || withImageFooter(gameDetail?.redTeamLogo)
            }
            if (gameDetail?.redTeamLogo) {
                return gameDetail?.redTeamLogo + Icon.ImageFooter
            } else {
                return Icon.KEPENG_LOGO
            }
        }
    }

    const teamName = (team) => {
        if (team === 1) {
            if (gameDetail?.gameType === 4) {
                return gameDetail?.greenName ?? 'A队'
            } else if (gameDetail?.gameType === 2) {
                return "华西科朋足球队"
            } else {
                return gameDetail?.greenName ?? 'A队'
            }
        } else if (team === 2) {
            if (gameDetail?.gameType === 4) {
                return gameDetail?.redName ?? 'B队'
            } else if (gameDetail?.gameType === 2) {
                return gameDetail?.redCaptain?.name ?? 'B队'
            } else {
                return gameDetail?.redName ?? 'B队'
            }
        }
        return '请设置队伍名称'
    }

    const renderTeamLogo = (team) => {
        const logoUrl = getLogoInfo(team);
        const isFallback = !logoUrl && ((isExternalMatch && team === 2) || currentGameType === 4);
        if (isFallback) {
            return (
                <div
                    className="scoreboard-avatar scoreboard-avatar-fallback"
                    title={teamName(team)}
                    style={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        border: `3px solid ${gameDetail?.redColor || "gray"}`
                    }}
                >
                    <span className="scoreboard-avatar-fallback-ball">⚽</span>
                    {/* 圆内仅放队名简称，完整名称在队徽下展示，防止长队名挤成竖排。 */}
                    <span className="scoreboard-avatar-fallback-name">{teamName(team).slice(0, 4)}</span>
                </div>
            )
        }
        return (
            <Image
                src={logoUrl}
                width={64}
                height={64}
                fit='cover'
                className="scoreboard-avatar"
                style={{
                    borderRadius: '50%',
                    border: `3px solid ${team === 1 ? (gameDetail?.greenColor || "gray") : (gameDetail?.redColor || "gray")}`,
                    backgroundColor: '#F5F7FA'
                }}
            />
        )
    }

    // Helper for Admin Editing
    const handleEditTeam = (team) => {
        if (memberInfo && memberInfo.admin === 1 && ![4].includes(gameDetail?.gameType)) {
            // Logic differs slightly for team 2 based on gameType in original code, simplifying for common case or keeping check
            // Original code blocked editing for team 2 if gameType is 1,2,4. 
            if (team === 2 && [1, 2, 4].includes(gameDetail?.gameType)) return;

            const currentName = team === 1 ? (gameDetail?.greenName ?? '绿队') : (gameDetail?.redName ?? '红队');
            const currentColor = team === 1 ? (gameDetail?.greenColor || "green") : (gameDetail?.redColor || "red");

            let groupName = currentName;
            let groupColor = [currentColor];

            Dialog.confirm({
                title: "修改队名",
                className: 'detail-glass-modal', // We might need to style this or use global dialog styles
                content: <div>
                    <div style={{ marginBottom: 10 }}>修改队名:</div>
                    <Input
                        placeholder='请输入队名'
                        defaultValue={currentName}
                        onChange={value => groupName = value}
                        style={{
                            padding: '8px',
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: '8px',
                            marginBottom: '10px',
                            background: 'rgba(255,255,255,0.05)',
                            color: '#1D2129'
                        }}
                    />
                    <div style={{ marginBottom: 10 }}>请选择队服颜色:</div>
                    <Selector
                        style={{ '--gap': '8px' }}
                        options={colorList}
                        defaultValue={[currentColor]}
                        onChange={(arr, _) => groupColor = arr}
                    />
                </div>,
                onConfirm: () => {
                    Toast.show({ icon: 'loading', duration: 0 })
                    axios.post(API_ROUTES.game_color, {
                        gameId: gameDetail?.id,
                        team: team,
                        teamName: groupName,
                        teamColor: groupColor[0]
                    }, null)
                        .then(function (response) {
                            getGameDetail()
                            Toast.show({ icon: 'success', content: '修改成功！' })
                        })
                        .catch(function (error) {
                            Toast.show({ icon: 'fail', content: "操作失败，请联系管理员！" })
                        })
                        .finally(() => Toast.clear());
                }
            })
        }
    }

    return (
        <div className="scoreboard-card">
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                padding: '0 12px'
            }}>
                {/* Team 1 */}
                <div
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '30%' }}
                    onClick={() => handleEditTeam(1)}
                >
                    {renderTeamLogo(1)}
                    <div className="scoreboard-team-name">
                        {teamName(1)}
                    </div>
                </div>

                {/* Score */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '40%' }}>
                    <div className="scoreboard-score">
                        {gameDetail?.greenGoal ?? 0}
                        <span style={{ margin: '0 8px', fontSize: '24px', opacity: 0.5 }}>:</span>
                        {gameDetail?.redGoal ?? 0}
                    </div>
                    {/* Game Status / Time */}
                    <div className="scoreboard-vs">
                        FINAL SCORE
                    </div>
                    <Tag
                        color='primary'
                        fill='outline'
                        style={{
                            marginTop: '8px',
                            border: '1px solid rgba(255,255,255,0.2)',
                            color: '#86909C',
                            background: 'rgba(255,255,255,0.05)'
                        }}
                    >
                        {/* 比赛类型使用后端名称，避免活动赛被误标成友谊赛。 */}
                        {gameDetail?.gameTypeName || gameDetail?.type || '比赛'}
                    </Tag>
                </div>

                {/* Team 2 */}
                <div
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '30%' }}
                    onClick={() => handleEditTeam(2)}
                >
                    {renderTeamLogo(2)}
                    <div className="scoreboard-team-name">
                        {teamName(2)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HistoryTitle;
